import { IAuditable } from './auditable-schema.interface';
import { AlertTypesEnum } from '../../enums';

export interface IAlertSchema {
    id?: string;
    sequenceId?: string;
    organizationId?: string;
    type: AlertTypesEnum;
    trip?: IAlertTrip;
    vehicle?: IAlertTripVehicle;
    driver?: IAlertTripDriver;
    stepName: string;
    source: string;
    createdAt?: string;
    updatedAt?: string;
    auditable: IAuditable;
    carrier?: IAlertCarrier;
}

export interface IAlertsInfo {
    total?: number;
    totalResolved?: number;
    totalPending?: number;
}

export interface IAlertTrip {
    id: string;
    code: string;
}

export interface IAlertCarrier {
    id?: string;
    name?: string;
}

export interface IAlertTripVehicle {
    id: string;
    licensePlate: string;
    name?: string;
}

export interface IAlertTripDriver {
    id: string;
    fullName: string;
}
